import * as React from "react"
const Steady2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#BDDEFF"
      fillRule="evenodd"
      d="M19.6 25.364a1.153 1.153 0 0 1-1.153-1.153v-6.917a1.153 1.153 0 0 1 2.306 0v6.917c0 .637-.517 1.153-1.153 1.153ZM8.07 11.53a1.153 1.153 0 0 1-1.153-1.154V3.46a1.153 1.153 0 0 1 2.306 0v6.917c0 .637-.516 1.153-1.153 1.153Z"
      clipRule="evenodd"
    />
    <path
      fill="#BDDEFF"
      d="M8.1 12.97c.512 0 .94 0 1.29.024.366.025.712.08 1.046.218a3.17 3.17 0 0 1 1.716 1.716c.139.334.193.68.218 1.046.024.35.024.778.024 1.29v.06c0 .511 0 .94-.024 1.29-.025.366-.079.711-.218 1.046a3.171 3.171 0 0 1-1.715 1.716c-.335.139-.68.192-1.046.217l-.167.009v2.609a1.154 1.154 0 0 1-2.306 0V21.6l-.168-.008c-.366-.025-.711-.078-1.046-.217a3.171 3.171 0 0 1-1.716-1.716c-.138-.335-.193-.68-.217-1.046-.024-.35-.024-.779-.024-1.29v-.06c0-.512 0-.94.024-1.29.024-.366.079-.712.217-1.046a3.17 3.17 0 0 1 1.716-1.716c.335-.139.68-.193 1.046-.218.351-.024.779-.023 1.291-.023H8.1ZM19.6 2.306c.636 0 1.153.516 1.153 1.153v2.608l.167.01c.365.025.711.078 1.046.217a3.17 3.17 0 0 1 1.716 1.716c.138.335.193.68.217 1.046.024.35.024.778.024 1.29v.06c0 .511 0 .94-.024 1.29-.024.366-.079.712-.217 1.046a3.17 3.17 0 0 1-1.716 1.716c-.335.139-.68.193-1.046.218-.351.024-.779.023-1.291.023h-.059c-.512 0-.94 0-1.29-.023-.366-.025-.712-.08-1.047-.218a3.17 3.17 0 0 1-1.715-1.716c-.139-.335-.193-.68-.218-1.046-.024-.35-.024-.778-.024-1.29v-.06c0-.512 0-.94.024-1.29.025-.366.079-.711.218-1.046a3.17 3.17 0 0 1 1.715-1.716c.335-.139.68-.192 1.046-.217a7.53 7.53 0 0 1 .167-.01V3.46c0-.637.517-1.153 1.154-1.153Z"
    />
  </svg>
)
export default Steady2
